export enum Path {
	Main = "/",
	CurrentMovie = "/currentmovie",
	PersonalArea = "/personalarea",
	Favorites = "/personalarea/personalarea",
	NotFound = "/*",
}
